import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import linkstate from 'linkstate';

const QUICK_MESSAGES = [
    { value: 'Husk å skrive ut resept', textId: 'dyrejournal.ready-for-pickup-chip-prescription' },
    { value: 'Husk fôr/varer', textId: 'dyrejournal.ready-for-pickup-chip-goods' },
    { value: 'Husk å booke ny time', textId: 'dyrejournal.ready-for-pickup-chip-appointment' },
];

@observer
class ReadyForPickup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
        };
    }

    onClickQuickMessage = e => {
        const { value } = e.target.closest('button').dataset;
        const { message = '' } = this.state;
        this.setState({ message: message ? `${message}\n${value}` : value });
    }

    onClickConfirm = async () => {
        const { callback = () => {} } = this.props;
        const { saleStore } = this.props.stores;
        const { message = '' } = this.state;

        saleStore.updateObjectKeyValue('newSale', 'readyForPickup', util.isoDate(new Date(), false, true));
        saleStore.updateObjectKeyValue('newSale', 'readyForPickupMessage', message);
        await saleStore.saveSale({
            calledFrom: 'readyForPickup.onClickMarkAsReadyForPickup',
            fieldsToSave: ['readyForPickup', 'readyForPickupMessage'],
        });
        callback(message);
    }

    render() {
        const { message } = this.state;

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        <i class='fa-solid fa-dog-leashed me-2' />
                        <Text id='dyrejournal.animal-ready-for-pickup'>Ready for pickup</Text>
                    </div>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3 px-3'>
                        <label class='form-label text-body-secondary'>
                            <Text id='dyrejournal.ready-for-pickup-message-label'>Message to the reception (optional)</Text>
                        </label>
                        <div class='d-flex flex-row flex-wrap mb-2'>
                            {QUICK_MESSAGES.map(chip => (
                                <button
                                    key={chip.textId}
                                    type='button'
                                    class='btn btn-sm btn-outline-secondary rounded-pill me-2 mb-2'
                                    data-value={chip.value}
                                    onClick={this.onClickQuickMessage}
                                >
                                    <i class='fa-regular fa-plus me-1' />
                                    <Text id={chip.textId}>{chip.value}</Text>
                                </button>
                            ))}
                        </div>
                        <textarea
                            class='form-control'
                            rows={4}
                            value={message}
                            onInput={linkstate(this, 'message')}
                        />
                    </div>
                    <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-success rounded-pill' onClick={this.onClickConfirm}>
                            <i class='fa-solid fa-dog-leashed me-1' />
                            <Text id='dyrejournal.ready-for-pickup-confirm'>Mark as ready for pickup</Text>
                        </button>
                    </div>
                </div>
            </div>
        </>);
    }
}

export default ReadyForPickup;
